var _circle, _rect, _g, _path, _path2, _g2, _rect2, _rect3, _rect4, _circle2, _rect5, _rect6, _path3, _rect7, _path4, _rect8, _rect9, _rect10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfigureSalesPage = function SvgConfigureSalesPage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152,
    height: 152,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 76,
    r: 76,
    fill: "#5981E3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 74.233,
    height: 64.512,
    x: 38.884,
    y: 44.186,
    fill: "#4770D8",
    rx: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#configure-sales-page_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.861,
    height: 53.907,
    x: 45.07,
    y: 49.488,
    fill: "#F3F4FB",
    rx: 4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#70A0F5",
    d: "M55.675 54.791h40.651v22.977H55.675z",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "configure-sales-page_svg__b",
    width: 42,
    height: 22,
    x: 55,
    y: 56,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.675 56.558h40.651v21.209H55.675z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#5981E3",
    mask: "url(#configure-sales-page_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.814 61.271 86.65 78.945H52.977l16.837-17.674Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.604 67.555 11.48 11.783h-22.96l11.48-11.783Z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40.651,
    height: 2.798,
    x: 55.675,
    y: 83.806,
    fill: "#C1D1EA",
    rx: 1.399
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 21.209,
    height: 2.798,
    x: 55.675,
    y: 89.403,
    fill: "#C1D1EA",
    rx: 1.399
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10.605,
    height: 2.651,
    x: 55.675,
    y: 95.442,
    fill: "#E37570",
    rx: 1.326
  })), /*#__PURE__*/React.createElement("mask", {
    id: "configure-sales-page_svg__c",
    width: 152,
    height: 152,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 76,
    r: 76,
    fill: "#5981E3"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#configure-sales-page_svg__c)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    style: {
      mixBlendMode: "soft-light"
    }
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 61.861,
    height: 53.907,
    x: 45.069,
    y: 121.954,
    fill: "#F3F4FB",
    rx: 4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 40.651,
    height: 26.512,
    x: 55.674,
    y: 129.907,
    fill: "#4770D8",
    opacity: 0.3,
    rx: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M72.543 134.042a.5.5 0 0 0-.485.379l-.12.485a1.5 1.5 0 0 1-1.456 1.136h-2.72a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-2.719a1.5 1.5 0 0 1-1.455-1.136l-.121-.485a.5.5 0 0 0-.485-.379h-4.439Zm-1.455.136a1.5 1.5 0 0 1 1.456-1.136h4.438a1.5 1.5 0 0 1 1.455 1.136l.121.485a.5.5 0 0 0 .485.379h2.72a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-14a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h2.719a.5.5 0 0 0 .485-.379l.121-.485Zm3.675 3.864a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-4 3a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    style: {
      mixBlendMode: "soft-light"
    }
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 61.861,
    height: 53.907,
    x: 45.069,
    y: -22.977,
    fill: "#F3F4FB",
    rx: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6ECF5",
    d: "M55.674-17.674h40.651V7.512H55.674z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 40.651,
    height: 2.798,
    x: 55.674,
    y: 11.341,
    fill: "#E6ECF5",
    rx: 1.399
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 30.047,
    height: 2.651,
    x: 60.977,
    y: 16.791,
    fill: "#E6ECF5",
    rx: 1.326
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 10.605,
    height: 2.651,
    x: 70.697,
    y: 22.977,
    fill: "#E37570",
    rx: 1.326
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "configure-sales-page_svg__a",
    width: 65.86,
    height: 57.907,
    x: 43.07,
    y: 48.488,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2158_288"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2158_288",
    result: "shape"
  })))));
};
export { SvgConfigureSalesPage as ReactComponent };
export default "data:image/svg+xml;base64,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";